import { render } from "./StageView.vue?vue&type=template&id=d48b658e"
import script from "./StageView.vue?vue&type=script&lang=js"
export * from "./StageView.vue?vue&type=script&lang=js"

import "./StageView.vue?vue&type=style&index=0&id=d48b658e&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__